export default __webpack_public_path__ + "static/platform-cost-d2b3d413d1353f1b613708560c9b5e1f.png";